import { ModalController } from '@ionic/angular';
import { Component, OnInit, ViewChild, ElementRef, NgZone, Input, } from '@angular/core';

import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';


import { Events } from '@providers/common/events.service';
import { ChatAIPopupService } from '@providers/chat/ai-chat.service';
import { SessionProvider } from '@providers/session/session.service';
import { AppStorageProvider } from '@providers/common/app-storage.service';
import { UtilityFunctionService } from '@providers/common/utilityFunction.service';
import { HtmlExcelExportService } from '@providers/excel/html-excel.service';

import { ResumeDetailChatAIModal } from '@components/modal-chat-ai-details/modal-resume-detail/modal-resume-detail.component';
import { TableDetailChatAIModal } from '@components/modal-chat-ai-details/modal-table-detail/modal-table-detail.component';
import { FullResumeDetailChatAIModal } from '@components/modal-chat-ai-details/modal-full-detail/modal-full-detail.component';
import { ChartDetailChatAIModal } from '@components/modal-chat-ai-details/modal-chart-detail/modal-chart-detail.component';

import { MyImageSwiperPreviewModal } from '@components/my-image-swiper-preview/my-image-swiper-preview.component';
import { MyImageSwiperViewModal } from '@components/my-image-swiper-view/my-image-swiper-view.component';

import { CdkDragMove } from '@angular/cdk/drag-drop';
import { FullMessageResponse, HtmlMessageDetail, Message, QuantronAccessInfo } from '@interfaces/Quantron/chat-quantron.interface';
import { addIcons } from "ionicons";
import { expandOutline, openOutline, pieChartSharp, close, hourglassOutline, flashOutline, checkmarkCircleOutline, send } from "ionicons/icons";

enum MaximixedModalView {
    Welcome = 'Welcome',
    Full = 'Full',
    Resume = 'Resume',
    TableFinance = 'TableFinance',
    TableOperations = 'TableOperations',
    TableComplete = 'TableComplete',
    Chart = 'Chart',
    ChartsMinitures = 'ChartsMinitures',
}

register();

@Component({
    selector: 'chat-ai-popup',
    templateUrl: './modal-chat-ai.component.html',
    styleUrls: ['./modal-chat-ai.component.scss'],
    standalone: false,
})
export class ChatAIPopUpModal implements OnInit {
    @Input() quantronAccessInfo: QuantronAccessInfo = new QuantronAccessInfo();

    @ViewChild('messagesContainer', { static: false })
    messagesContainer!: ElementRef;
    @ViewChild('popover') popover!: HTMLIonPopoverElement;

    @ViewChild('resizeBox') resizeBox!: ElementRef;
    @ViewChild('sideChatDetailsBox') sideChatDetailsBox!: ElementRef;
    @ViewChild('dragHandleCorner') dragHandleCorner!: ElementRef;
    @ViewChild('dragHandleRight') dragHandleRight!: ElementRef;
    @ViewChild('dragHandleTop') dragHandleTop!: ElementRef;

    mainChatBoxClass: string = 'chat-popup';
    topHeaderChatBoxClass: string = 'ion-top-border-rounded-x10';
    bottomHeaderChatBoxClass: string = 'ion-bottom-border-rounded-x10';

    messages: Message[] = [];
    fullMessagesLog: {
        messageKey: string;
        messageInfo: FullMessageResponse;
    }[] = [];

    newMessage: string = '';
    isTyping: boolean = false;
    chartsIsEnabled: boolean = true;
    isOpenChartPopover = false;
    isOpenMaxPopover = false;
    /* AI Response Messages Vaiables */
    backendSessionId: string = '';
    currentSessionId: string = '';
    currentMsgKeyTemp: string = '';

    minResumeMessage: string = '';
    resumeMessage: string = '';
    minTableResumeMessage: string = '';
    tableResumeMessage: string = '';
    minChartResumeMessage: string = '';
    chartResumeMessage: string = '';
    minCostoTiempoResumeMessage: string = '';
    costoTiempoResumeMessage: string = '';
    btnFullDetailEnabled: boolean = false;
    /* AI Response Messages Vaiables */

    isMaximixedChatWindow: boolean = false;
    chatCurrentWidth: number = 450;
    tempWidthChatBox: string = '';
    tempHeigthChatBox: string = '';
    maximixedModalView: MaximixedModalView = MaximixedModalView.Welcome;

    sideModalTitle: string = '';
    resumeDetail: string = '';
    tableDetail: string = '';
    tableOperationsDetail: string = '';
    tableFinanceDetail: string = '';
    chartDetail: string = '';
    chartsDetail: string[] = [];

    private chartsCarouselEl?: ElementRef;
    @ViewChild('chartsCarousel') set chartsCarousel(el: ElementRef | undefined) {
        if (el) {
            Object.assign(el.nativeElement, this.config);
            el.nativeElement.initialize();
            this.chartsCarouselEl = el;
        }
    }
    config: SwiperOptions = {
        centeredSlides: true,
        slidesPerView: 1,
        navigation: true,
        loop: true,
        pagination: false,
        initialSlide: 0,
        // pagination: { clickable: true, dynamicBullets: true },
    };
    imagesSlider: string[] = [];

    sliderOpt = {
        zoom: false,
        centeredSlides: true,
    };

    sliderCurrentImgSlide: number = 0;
    hasSlides: boolean = false;
    sliderLoadedFullView: boolean = false;
    sliderLoadedFullViewToken: string = '';
    hasErrorQuantronResponse: boolean = false;

    constructor(
        private modalCtrl: ModalController,
        private events: Events,
        private chatAIServ: ChatAIPopupService,
        private ngZone: NgZone,
        private sessionProvider: SessionProvider,
        private storage: AppStorageProvider,
        private utilityService: UtilityFunctionService,
        private excelExport: HtmlExcelExportService,

    ) {
        addIcons({ expandOutline, openOutline, pieChartSharp, close, hourglassOutline, flashOutline, checkmarkCircleOutline, send });
    }

    ngOnInit() {
        this.events.subscribe('chatAI:active', (state: boolean) => {

            if (state) {
                this.isTyping = true;
                console.log('Modal Chat is Active!');

                this.setAllHandleTransform();

                this.getQuantronInfo();
            }

        });
    }

    async getQuantronInfo() {
        this.quantronAccessInfo = await this.storage.get<QuantronAccessInfo>('quantron:enabled');

        setTimeout(() => {
            this.onLoadMessagesInChat();
        }, 100);
    }

    onLoadMessagesInChat() {
        this.isTyping = false;
        console.log('Access: ', this.quantronAccessInfo.access);

        if (this.quantronAccessInfo.access) {
            if (this.messages.length === 0) {

                this.addWelcomeMessage();
            }
        } else {
            this.addSessionValidateMessage();
        }

    }

    ngAfterViewInit() {
        /* console.log('Access: ', this.quantronAccessInfo.access);
    
        if (this.quantronAccessInfo.access) {
          this.addWelcomeMessage();
        } else {
          this.addSessionValidateMessage();
        } */

        // console.log('ngAfterViewInit!');
    }

    onResetInitialChatState() {
        this.isMaximixedChatWindow = false;
        this.maximixedModalView = MaximixedModalView.Welcome;

        this.mainChatBoxClass = 'chat-popup';
        this.topHeaderChatBoxClass = 'ion-top-border-rounded-x10';
        this.bottomHeaderChatBoxClass = 'ion-bottom-border-rounded-x10';
    }

    presentChartEnabledToast(e: Event) {
        this.isOpenChartPopover = true;
    }

    addWelcomeMessage() {
        this.messages.push({
            text:
                'Bienvenido 👋 Soy Quantron, tu agente inteligente.<br><br>' +
                'Actualmente estoy especializado en consultas financieras.<br>' +
                'Ofrezco respuestas rápidas, insights accionables y, cuando lo requieras, visualizaciones claras y precisas.<br><br>' +
                '📊 Puedes activar o desactivar la generación de gráficos con el toggle en la parte superior.',
            isUser: false,
            timestamp: new Date(),
            messageKey: '',
            htmlMessageDetail: new HtmlMessageDetail(),
        });
    }

    addSessionValidateMessage() {
        this.messages.push({
            text: 'Parece que Quantron no puede validar tu sessión. Por favor, recargue la página o inténtelo de nuevo en unos minutos.',
            isUser: false,
            timestamp: new Date(),
            messageKey: '',
            htmlMessageDetail: new HtmlMessageDetail(),
        });
    }

    sendMessage() {
        if (this.newMessage.trim()) {
            this.messages.push({
                text: this.newMessage,
                isUser: true,
                timestamp: new Date(),
                messageKey: '',
                htmlMessageDetail: new HtmlMessageDetail(),
            });

            const userMessage = this.newMessage;
            this.newMessage = '';
            this.scrollToBottom();

            this.sendMessageToLambda(userMessage);
        }
    }

    scrollToBottom() {
        setTimeout(() => {
            if (this.messagesContainer) {
                this.messagesContainer.nativeElement.scrollTop =
                    this.messagesContainer.nativeElement.scrollHeight;
            }
        }, 100);
    }

    closeModal() {
        this.events.publish('chatAI:change', false);
        this.events.publish('chatAI:active', false);
        this.onResetInitialChatState();

        // this.modalCtrl.dismiss();
    }

    async sendMessageToLambda(message: string) {
        this.isTyping = true;

        const execution_id = this.sessionProvider.key + '_' + Date.now();

        let lamdaURL = this.quantronAccessInfo.Lambda_Main_Url;
        // let lamdaURL = 'https://zpd3ngacwjjgqb7u4quglmc4de0gfyoe.lambda-url.us-east-1.on.aws/';
        let lamdaApi = this.quantronAccessInfo.Api_Key;

        // Generar session ID único
        this.currentSessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

        this.chatAIServ
            .getSendMessage(
                lamdaURL,
                lamdaApi,
                message,
                this.chartsIsEnabled,
                this.backendSessionId,
                this.sessionProvider.key,
                execution_id
            )
            .then((resp: any) => {
                // console.log('getSendMessage: ', resp);

                if (resp) {
                    if (resp.error) {
                        // console.log('Error! getSendMessage: ', resp);

                        this.hasErrorQuantronResponse = true;
                        const messageKey = 'error-message-' + Date.now();
                        let messageError = new HtmlMessageDetail();
                        messageError.minResumeHtml = resp.error;

                        this.addMessage(messageKey, messageError);
                    } else {
                        this.hasErrorQuantronResponse = false;
                        this.isTyping = true;

                        // console.log('OK! getSendMessage: ', resp);

                        let messageTemp = new HtmlMessageDetail();
                        messageTemp.minResumeHtml = '';
                        messageTemp.dataIsVisible = true;
                        messageTemp.insightsIsVisible = true;
                        messageTemp.chartsIsVisible = true;
                        messageTemp.dataShown = false;
                        messageTemp.insightsFastShown = false;
                        messageTemp.chartsFastShown = false;
                        messageTemp.insightsCompleteShown = false;
                        messageTemp.chartsCompleteShown = false;

                        // Mostrar Progressive Cards
                        this.addMessage(this.currentSessionId, messageTemp);

                        this.questionProgressivePolling(execution_id);
                    }
                }
            });
    }

    async questionProgressivePolling(executionId: string) {
        let lamdaPollingURL = this.quantronAccessInfo.Lambda_Polling_Url + '?execution_id=' + executionId;
        // let lamdaPollingURL = 'https://oz2icxmqvx4f2dgtrbtrvqxkoi0eocxd.lambda-url.us-east-1.on.aws/?execution_id=' + executionId;

        // Esperar 3s antes de empezar polling
        await new Promise(resolve => setTimeout(resolve, 3000));

        // Polling cada 2s
        const pollInterval = setInterval(async () => {
            const msgData = this.messages.find(
                (item) => item.messageKey === this.currentSessionId,
            );
            if (!msgData) return;

            try {
                const response = await fetch(lamdaPollingURL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

                const data = await response.json();
                // console.log('Polling data received:', data);

                // Detectar intent_type y ocultar tarjetas si es GENERAL_QUESTION
                if (data.intent_type === 'GENERAL_QUESTION') {
                    // console.log('General question detected, hiding DATA and GRAPHS cards');
                    msgData.htmlMessageDetail.dataIsVisible = false;
                    msgData.htmlMessageDetail.chartsIsVisible = false;
                }

                // Guardar session_id del backend cuando llegue
                if (data.session_id && !this.backendSessionId) {
                    this.backendSessionId = data.session_id;
                    // console.log('Session ID received from backend:', this.backendSessionId);
                }

                // Actualizar card de datos cuando estén listos
                if ((data.formatted_table_finance || data.formatted_table_operations) && !
                    msgData.htmlMessageDetail.dataShown) {
                    this.updateDataCard(this.currentSessionId, data, msgData, 'ready');
                    msgData.htmlMessageDetail.dataShown = true;
                }

                // Actualizar card de datos en cada polling si hay datos de la sesión actual
                if (data.formatted_table_finance || data.formatted_table_operations) {
                    this.updateDataCard(this.currentSessionId, data, msgData, 'ready');
                }

                // Mostrar insights rápidos primero
                if (data.insights_fast && !msgData.htmlMessageDetail.insightsFastShown) {
                    this.updateInsightsCard(data.insights_fast, msgData, 'fast');
                    msgData.htmlMessageDetail.insights_fast = data.insights_fast;
                    msgData.htmlMessageDetail.insightsFastShown = true;
                }

                // Mostrar general_answer si existe
                if (data.general_answer && !msgData.htmlMessageDetail.insightsCompleteShown) {
                    // Ocultar tarjetas DATA y GRAPHS si es general question
                    msgData.htmlMessageDetail.dataIsVisible = false;
                    msgData.htmlMessageDetail.chartsIsVisible = false;

                    this.updateInsightsCard(data.general_answer, msgData, 'ready');
                    msgData.htmlMessageDetail.insights = data.general_answer;
                    msgData.htmlMessageDetail.insightsFastShown = true;
                    msgData.htmlMessageDetail.insightsCompleteShown = true;
                    clearInterval(pollInterval); // Detener polling para general questions
                }

                // Reemplazar con insights completos cuando estén listos
                if (data.insights && data.insights !== data.insights_fast && !msgData.htmlMessageDetail.insightsCompleteShown) {
                    this.updateInsightsCard(data.insights, msgData, 'ready');
                    msgData.htmlMessageDetail.insights = data.insights;
                    msgData.htmlMessageDetail.insightsCompleteShown = true;
                }

                // Mostrar charts rápidos solo si están habilitados
                if (this.chartsIsEnabled && data.charts_fast && data.charts_fast.length > 0 && !msgData.htmlMessageDetail.chartsFastShown) {
                    this.updateChartsCard(data.charts_fast, msgData, 'fast');
                    msgData.htmlMessageDetail.chartsFastShown = true;
                }

                // Mostrar charts completos solo si están habilitados
                if (data.status === 'complete') {
                    if (this.chartsIsEnabled && data.charts && data.charts.length > 0 && !msgData.htmlMessageDetail.chartsCompleteShown) {
                        this.updateChartsCard(data.charts, msgData, 'ready');
                        msgData.htmlMessageDetail.chartsCompleteShown = true;
                    }
                    clearInterval(pollInterval);
                }

                // Detener polling cuando insights están listos (sin gráficos o gráficos deshabilitados)
                if (data.status === 'insights_ready' && (!this.chartsIsEnabled || data.chart_status === 'disabled')) {
                    clearInterval(pollInterval);
                }

                // Detener polling cuando charts están listos
                if (data.status === 'insights_ready' && this.chartsIsEnabled && data.charts && data.charts.length > 0) {
                    if (!msgData.htmlMessageDetail.chartsCompleteShown) {
                        this.updateChartsCard(data.charts, msgData, 'ready');
                        msgData.htmlMessageDetail.chartsCompleteShown = true;
                    }
                    clearInterval(pollInterval);
                }

                if (data.status === 'error') {
                    console.error('Execution error:', data.error);
                    clearInterval(pollInterval);

                    this.hasErrorQuantronResponse = true;
                    const messageKey = 'error-message-' + Date.now();
                    let messageError = new HtmlMessageDetail();
                    messageError.minResumeHtml = '❌ Error: ' + data.error;

                    this.addMessage(messageKey, messageError);
                }

                // Log para debugging
                /* console.log('Polling status:', data.status, 'Charts enabled:', this.chartsIsEnabled,
                  'Chart status:', data.chart_status); */
            } catch (error) {
                console.error('Polling error: ', JSON.stringify(error));
                clearInterval(pollInterval);

                // addMessage(`❌ Error de polling: ${error.message}`, 'bot');
            }
        }, 2000);

        // Timeout después de 10 minutos
        setTimeout(() => {
            clearInterval(pollInterval);
        }, 600000);
    }

    updateDataCard(sessionId: string, data: any, msgData: Message, status = 'ready') {
        // Solo actualizar con los datos recibidos (no acumular de otras sesiones)
        if (data.formatted_table_finance) {
            // console.log('Storing finance table');
            msgData.htmlMessageDetail.formatted_table_finance = data.formatted_table_finance;
        }

        if (data.formatted_table_operations) {
            // console.log('Storing operations table');
            msgData.htmlMessageDetail.formatted_table_operations = data.formatted_table_operations;
        }

        if (data.query_results_finance) {
            msgData.htmlMessageDetail.query_results_finance = data.query_results_finance;
        }

        if (data.query_results_operations) {
            msgData.htmlMessageDetail.query_results_operations = data.query_results_operations;
        }

        // Guardar is_multi_domain si viene en data
        if ('is_multi_domain' in data) {
            msgData.htmlMessageDetail.is_multi_domain = data.is_multi_domain;
        }

        // Usar solo los datos de la sesión actual para mostrar el contenido
        const isMultiDomain = msgData.htmlMessageDetail.is_multi_domain || false;

        let response = '';

        if (msgData.htmlMessageDetail.formatted_table_finance || msgData.htmlMessageDetail.formatted_table_operations) {

            if (msgData.htmlMessageDetail.formatted_table_finance) {
                // console.log('Rendering finance table');

                response = '';
                const financePreview = this.getTablePreview(msgData.htmlMessageDetail.formatted_table_finance, 2);

                const minTableHtml = '<div class="scroll-content-x scroll-content-custom-color">' +
                    this.formatTableAsHTML(financePreview, 'financial') +
                    '</div>';

                response += minTableHtml;

                msgData.htmlMessageDetail.minFinanceTableResumeHtml = minTableHtml;
            }

            if (msgData.htmlMessageDetail.formatted_table_operations) {
                // console.log('Rendering operations table');

                response = '';
                const operationsPreview = this.getTablePreview(msgData.htmlMessageDetail.formatted_table_operations, 2);

                const minTableHtml = '<div class="scroll-content-x scroll-content-custom-color">' +
                    this.formatTableAsHTML(operationsPreview, 'operations') +
                    '</div>';

                response += minTableHtml;

                msgData.htmlMessageDetail.minOperationsTableResumeHtml = minTableHtml;
            }
        } else {
            msgData.htmlMessageDetail.minFinanceTableResumeHtml = '';
            msgData.htmlMessageDetail.minOperationsTableResumeHtml = '';
        }

        // Determinar si cambiar a ready basado en is_multi_domain
        if (isMultiDomain) {
            // Multi-domain: necesitamos ambas tablas
            if (msgData.htmlMessageDetail.formatted_table_finance || msgData.htmlMessageDetail.formatted_table_operations) {
                msgData.htmlMessageDetail.dataCardStatus = 2; // 2 = Ready

            } else {
                msgData.htmlMessageDetail.dataCardStatus = 0; // 0 = Loading
            }
        } else {
            // Single domain: con una tabla es suficiente
            if (msgData.htmlMessageDetail.formatted_table_finance || msgData.htmlMessageDetail.formatted_table_operations) {
                msgData.htmlMessageDetail.dataCardStatus = 2; // 2 = Ready
            } else {
                msgData.htmlMessageDetail.dataCardStatus = 0; // 0 = Loading
            }
        }
    }

    updateInsightsCard(insights: any, msgData: Message, status = 'fast') {
        const summary = this.extractInsightsSummary(insights);
        const content = this.convertMarkdownToHtml(summary);

        msgData.htmlMessageDetail.minResumeHtml = content;
        msgData.htmlMessageDetail.insightsCardStatus = status === 'fast' ? 1 : status === 'ready' ? 2 : 0;
    }

    updateChartsCard(charts, msgData: Message, status = 'fast') {
        // Guardar charts en window.messageData para modales
        msgData.htmlMessageDetail.charts = charts;
        msgData.htmlMessageDetail.chartsCardStatus = status === 'fast' ? 1 : status === 'ready' ? 2 : 0;
    }

    addMessage(key: string, htmlElements: HtmlMessageDetail) {
        setTimeout(() => {
            this.isTyping = false;

            this.messages.push({
                text: '',
                isUser: false,
                timestamp: new Date(),
                messageKey: key,
                htmlMessageDetail: htmlElements,
            });

            this.scrollToBottom();
        }, 1000);
    }

    extractInsightsSummary(insights) {
        const executiveSummaryMatch = insights.match(/##?\s*📊\s*Resumen Ejecutivo[\s\S]*?(?=\n##|\n#|$)/i);

        if (executiveSummaryMatch) {
            return executiveSummaryMatch[0]
                .replace(/##?\s*📊\s*Resumen Ejecutivo\s*\n?/i, '')
                .trim();
        }

        const insightsLines = insights.split('\n').filter(line => line.trim() && !line.match(/^#|^📊|^🔍/));
        return insightsLines.slice(0, 3).join('\n');
    }

    convertMarkdownToHtml(markdown) {
        return markdown
            .replace(/^# (.*$)/gm, '<h1>$1</h1>')
            .replace(/^## (.*$)/gm, '<h2>$1</h2>')
            .replace(/^### (.*$)/gm, '<h3>$1</h3>')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            .replace(
                /`(.*?)`/g,
                '<code style="background: #f0f0f0; padding: 2px 4px; border-radius: 3px; ">$1</code>',
            )
            .replace(/\n\n/g, '</p><p>')
            .replace(/^(.*)$/gm, '<p>$1</p>')
            .replace(/<p><\/p>/g, '')
            .replace(/<p>(<h[1-6]>.*<\/h[1-6]>)<\/p>/g, '$1');
    }

    formatTableAsHTML(tableData, tableType: string) {
        const lines = tableData.split('\n');
        const headerIndex = lines.findIndex((line) => line.includes('|'));

        if (headerIndex === -1) {
            return (
                '<pre style="font-family: monospace; white-space: pre-wrap; ">' +
                tableData +
                '</pre>'
            );
        }

        const header = lines[headerIndex];
        const dataLines = lines
            .slice(headerIndex + 2)
            .filter((line) => line.trim() && line.includes('|'));

        if (!header || dataLines.length === 0) {
            return (
                '<pre style="font-family: monospace; white-space: pre-wrap; ">' +
                tableData +
                '</pre>'
            );
        }

        const headerCells = header
            .split('|')
            .map((cell) => cell.trim())
            .filter((cell) => cell);

        let html = '<table class="' + tableType + '-table"><thead><tr>';

        // console.log(JSON.stringify(headerCells));

        headerCells.forEach((cell: string) => {
            cell = this.titleCaseWord(cell);
            html += '<th>' + cell.replace(/_/g, ' ') + '</th>';
        });

        html += '</tr></thead><tbody>';

        dataLines.forEach((line, index) => {
            const cells = line
                .split('|')
                .map((cell) => cell.trim())
                .filter((cell) => cell);

            html += '<tr>';
            cells.forEach((cell: any) => {
                // Formatear números a 2 decimales si es un número
                let formattedCell = cell;
                if (!isNaN(parseFloat(cell)) && isFinite(cell) && cell.includes('.')) {
                    formattedCell = parseFloat(cell).toFixed(2);
                }

                html += '<td>' + formattedCell + '</td>';
            });
            html += '</tr>';
        });

        html += '</tbody></table>';

        return html;
    }

    getTablePreview(tableData, maxRows = 3) {
        const lines = tableData.split('\n');
        const headerIndex = lines.findIndex((line) => line.includes('|'));

        if (headerIndex === -1) return tableData;

        const header = lines[headerIndex];
        const separator = lines[headerIndex + 1];
        const dataLines = lines
            .slice(headerIndex + 2)
            .filter((line) => line.trim() && line.includes('|'));

        const previewLines = dataLines.slice(0, maxRows);

        let preview = lines.slice(0, headerIndex).join('\n') + '\n';
        preview += header + '\n';
        preview += separator + '\n';
        preview += previewLines.join('\n');

        if (dataLines.length > maxRows) {
            preview += '\n... y ' + (dataLines.length - maxRows) + ' filas más';
        }

        return preview;
    }

    titleCaseWord(word: string) {
        if (!word) return word;
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
    }

    async openModalMaximizedChat() {
        this.tempWidthChatBox = this.resizeBoxElement.style.width;
        this.tempHeigthChatBox = this.resizeBoxElement.style.height;

        this.isMaximixedChatWindow = true;

        this.mainChatBoxClass =
            'maximixed-chat-popup maximixed-chat-left-side-border';
        this.topHeaderChatBoxClass = 'ion-top-left-border-rounded-x10';
        this.bottomHeaderChatBoxClass = 'ion-bottom-left-border-rounded-x10';
        this.resizeBoxElement.style.width = '450px';
        this.chatCurrentWidth = 450;

        this.setAllHandleTransform();
    }

    async closeModalMaximizedChat() {
        this.isMaximixedChatWindow = false;
        this.maximixedModalView = MaximixedModalView.Welcome;

        this.mainChatBoxClass = 'chat-popup';
        this.topHeaderChatBoxClass = 'ion-top-border-rounded-x10';
        this.bottomHeaderChatBoxClass = 'ion-bottom-border-rounded-x10';
        this.reassignChatDimensions();
    }

    async openModalResumeDetail(strMsg: string) {
        const msgData = this.messages.find(
            (item) => item.messageKey === strMsg,
        );
        // console.log('Data: ', JSON.stringify(msgData));

        if (msgData) {
            let resumeDetailHtml = '';
            if (msgData.htmlMessageDetail.insightsFastShown) {
                resumeDetailHtml = this.convertMarkdownToHtml(
                    msgData.htmlMessageDetail.insights_fast
                );
            }

            if (msgData.htmlMessageDetail.insightsCompleteShown && msgData.htmlMessageDetail.insightsFastShown) {
                resumeDetailHtml = this.convertMarkdownToHtml(
                    msgData.htmlMessageDetail.insights
                );
            }

            // console.log('resumeDetailHtml: ', JSON.stringify(resumeDetailHtml));

            if (this.isMaximixedChatWindow) {
                this.resumeDetail = resumeDetailHtml;

                setTimeout(() => {
                    this.sideModalTitle = 'INSIGHTS';
                    this.maximixedModalView = MaximixedModalView.Resume;
                    this.sliderLoadedFullView = false;
                }, 500);
            } else {
                const modal = await this.modalCtrl.create({
                    component: ResumeDetailChatAIModal,
                    componentProps: {
                        modalTitle: 'INSIGHTS',
                        resumeDetail: resumeDetailHtml,
                    },
                    cssClass: 'fullscreen',
                    mode: 'md',
                });

                return await modal.present();
            }
        }
    }

    async assignTableDetail(event: Event, strMsg: string, tableType: string) {
        event.stopPropagation();

        const msgData = this.messages.find(
            (item: Message) => item.messageKey === strMsg,
        );
        if (!msgData?.htmlMessageDetail) return;

        this.currentMsgKeyTemp = strMsg;
        // console.log('Data: ', JSON.stringify(msgData));

        if (tableType === 'Finance') {
            if (msgData.htmlMessageDetail.formatted_table_finance) {
                const tableTitle = 'Data - Financial';
                const tableFinanceDetailHtml = this.tableFinanceDetail = this.formatTableAsHTML(msgData.htmlMessageDetail.formatted_table_finance, 'financial');
                // console.log('tableDetailHtml: ', JSON.stringify(tableDetailHtml));

                this.openModalTableDetail(tableFinanceDetailHtml, '', tableTitle, tableType, MaximixedModalView.TableFinance);
            }
        }

        if (tableType === 'Operations') {
            if (msgData.htmlMessageDetail.formatted_table_operations) {
                const tableTitle = 'Data - Operations';
                const tableOperationsDetailHtml = this.tableOperationsDetail = this.formatTableAsHTML(msgData.htmlMessageDetail.formatted_table_operations, 'operations');
                // console.log('tableDetailHtml: ', JSON.stringify(tableDetailHtml));

                this.openModalTableDetail('', tableOperationsDetailHtml, tableTitle, tableType, MaximixedModalView.TableOperations);
            }
        }

    }

    async assignCompleteTableDetail(strMsg: string) {
        const msgData = this.messages.find(
            (item) => item.messageKey === strMsg,
        );
        if (!msgData) return;

        this.currentMsgKeyTemp = strMsg;
        // console.log('Data: ', JSON.stringify(msgData));

        if (msgData.htmlMessageDetail.formatted_table_finance || msgData.htmlMessageDetail.formatted_table_operations) {
            const tableTitle = 'Data';
            const tableFinanceDetailHtml = this.tableFinanceDetail = msgData.htmlMessageDetail.formatted_table_finance.length > 0 ? this.formatTableAsHTML(msgData.htmlMessageDetail.formatted_table_finance, 'financial') : '';
            const tableOperationsDetailHtml = this.tableOperationsDetail = msgData.htmlMessageDetail.formatted_table_operations.length > 0 ? this.formatTableAsHTML(msgData.htmlMessageDetail.formatted_table_operations, 'operations') : '';

            // console.log('tableFinanceDetailHtml: ', tableFinanceDetailHtml);
            // console.log('tableOperationsDetailHtml: ', tableOperationsDetailHtml);

            this.openModalTableDetail(tableFinanceDetailHtml, tableOperationsDetailHtml, tableTitle, 'Complete', MaximixedModalView.TableComplete);
        }

    }

    async openModalTableDetail(tableFinanceDetailHtml: string, tableOperationsDetailHtml: string, tableTitle: string, type: string, viewType: MaximixedModalView) {
        // console.log('tableDetailHtml: ', JSON.stringify(tableDetailHtml));

        if (this.isMaximixedChatWindow) {
            this.tableDetail = tableFinanceDetailHtml;
            this.tableFinanceDetail = tableFinanceDetailHtml;
            this.tableOperationsDetail = tableOperationsDetailHtml;

            setTimeout(() => {
                this.sideModalTitle = tableTitle;
                this.maximixedModalView = viewType;
                this.sliderLoadedFullView = false;
            }, 500);
        } else {
            const modal = await this.modalCtrl.create({
                component: TableDetailChatAIModal,
                componentProps: {
                    modalTitle: tableTitle,
                    modalType: type,
                    tableFinanceDetail: tableFinanceDetailHtml,
                    tableOperationsDetail: tableOperationsDetailHtml,
                },
                cssClass: 'fullscreen',
                mode: 'md',
            });

            return await modal.present();
        }
    }

    async openModalChartDetail(event: Event, strMsg: string, imageIdx: number) {
        event.stopImmediatePropagation();

        const msgData = this.messages.find(
            (item) => item.messageKey === strMsg,
        );
        if (!msgData) return;

        this.sliderCurrentImgSlide = imageIdx + 1;

        if (msgData.htmlMessageDetail.charts.length > 0) {
            let chartsDetailHtml: any[] = [];

            if (msgData.htmlMessageDetail.charts.length > 0) {
                msgData.htmlMessageDetail.charts.some((item: any) => {
                    chartsDetailHtml.push('data:image/png;base64,' + item.chart_base64);
                });
            }

            if (this.isMaximixedChatWindow) {
                if (this.sliderLoadedFullView && this.sliderLoadedFullViewToken === strMsg) {
                    this.goToSlide(imageIdx);
                } else {
                    this.chartsDetail = this.imagesSlider = chartsDetailHtml;
                    this.config.initialSlide = imageIdx;
                    // this.goToSlide(imageIdx);

                    setTimeout(() => {
                        this.sideModalTitle = 'VISUALIZATIONS';
                        this.maximixedModalView = MaximixedModalView.Chart;
                        this.sliderLoadedFullView = true;
                        this.sliderLoadedFullViewToken = strMsg;

                        this.goToSlide(imageIdx);

                    }, 100);
                }
            } else {
                this.chartsDetail = this.imagesSlider = chartsDetailHtml;

                if (this.imagesSlider.length > 0) {
                    this.onOpenImageSwiperModal(imageIdx);
                }
            }
        }
    }

    async openModalCompleteMinitureChartDetail(strMsg: string) {
        const msgData = this.messages.find(
            (item) => item.messageKey === strMsg,
        );
        if (!msgData) return;

        if (msgData.htmlMessageDetail.charts.length > 0) {
            this.chartsDetail = this.imagesSlider = [];
            let chartsDetailHtml: any[] = [];

            if (msgData.htmlMessageDetail.charts.length > 0) {
                msgData.htmlMessageDetail.charts.some((item: any) => {
                    chartsDetailHtml.push('data:image/png;base64,' + item.chart_base64);
                });
            }

            if (this.isMaximixedChatWindow) {
                this.chartsDetail = this.imagesSlider = chartsDetailHtml;

                setTimeout(() => {
                    this.sideModalTitle = 'VISUALIZATIONS';
                    this.maximixedModalView = MaximixedModalView.ChartsMinitures;
                    this.sliderLoadedFullView = false;
                }, 500);
            } else {
                this.chartsDetail = this.imagesSlider = chartsDetailHtml;

                if (this.imagesSlider.length > 0) {
                    this.onOpenImageSwiperModal(0);
                }
            }
        }
    }

    /* async openModalFullDetail(strMsg: string) {
      const msgData = this.fullMessagesLog.find(
        (item) => item.messageKey === strMsg,
      );
      // console.log('Data: ', JSON.stringify(msgData));
  
      if (msgData || msgData.messageInfo.insights) {
        const resumeDetailHtml = this.convertMarkdownToHtml(
          msgData.messageInfo.insights,
        );
  
        const tableFinanceDetailHtml = msgData.messageInfo.financeTable ? this.formatTableAsHTML(msgData.messageInfo.financeTable) : '';
        const tableOperationsDetailHtml = msgData.messageInfo.operationsTable ? this.formatTableAsHTML(msgData.messageInfo.operationsTable) : '';
        const tableDetailHtml = msgData.messageInfo.singleTable ? this.formatTableAsHTML(msgData.messageInfo.singleTable) : '';
        // console.log('resumeDetailHtml: ', JSON.stringify(resumeDetailHtml));
  
        let chartDetailHtml = '';
        let chartsDetailHtml = [];
        if (msgData.messageInfo.chartBase64) {
          chartDetailHtml =
            'data:image/png;base64,' + msgData.messageInfo.chartBase64;
        }
  
        if (msgData.messageInfo.chartsBase64.length > 0) {
          msgData.messageInfo.chartsBase64.some((item: string) => {
            chartsDetailHtml.push('data:image/png;base64,' + item);
          });
        }
  
        if (this.isMaximixedChatWindow) {
          this.resumeDetail = resumeDetailHtml;
          this.tableFinanceDetail = tableFinanceDetailHtml;
          this.tableOperationsDetail = tableOperationsDetailHtml;
          this.tableDetail = tableDetailHtml;
          this.chartDetail = chartDetailHtml;
          this.chartsDetail = this.imagesSlider = chartsDetailHtml;
  
          setTimeout(() => {
            this.sideModalTitle = 'INSIGHTS';
            this.maximixedModalView = MaximixedModalView.Full;
            this.sliderLoadedFullView = false;
          }, 500);
        } else {
          const modal = await this.modalCtrl.create({
            component: FullResumeDetailChatAIModal,
            componentProps: {
              modalTitle: 'INSIGHTS',
              resumeDetail: resumeDetailHtml,
              tableFinanceDetail: tableFinanceDetailHtml,
              tableOperationsDetail: tableOperationsDetailHtml,
              tableDetail: tableDetailHtml,
              chartDetail: chartDetailHtml,
              chartsDetail: chartsDetailHtml,
            },
            cssClass: 'fullscreen',
            mode: 'md',
          });
  
          return await modal.present();
        }
      }
    } */

    clearSideModalView() {
        this.maximixedModalView = MaximixedModalView.Welcome;
        this.sideModalTitle = '';
        this.sliderLoadedFullView = false;
    }

    /* Resize Functions */
    get resizeBoxElement(): HTMLElement {
        return this.resizeBox.nativeElement;
    }

    get sideChatDetailsBoxElement(): HTMLElement {
        return this.sideChatDetailsBox.nativeElement;
    }

    get dragHandleCornerElement(): HTMLElement {
        return this.dragHandleCorner.nativeElement;
    }

    get dragHandleRightElement(): HTMLElement {
        return this.dragHandleRight.nativeElement;
    }

    get dragHandleTopElement(): HTMLElement {
        return this.dragHandleTop.nativeElement;
    }

    setAllHandleTransform() {
        const rect = this.resizeBoxElement.getBoundingClientRect();
        if (this.isMaximixedChatWindow) {
            this.setHandleTransform(this.dragHandleRightElement, rect, 'x');
        } else {
            this.setHandleTransform(this.dragHandleCornerElement, rect, 'both');
        }
        // this.setHandleTransform(this.dragHandleTopElement, rect, 'y');
    }

    setHandleTransform(
        dragHandle: HTMLElement,
        targetRect: ClientRect | DOMRect,
        position: 'x' | 'y' | 'both',
    ) {
        const dragRect = dragHandle.getBoundingClientRect();
        const translateX = targetRect.width;
        const translateY = targetRect.height - dragRect.height;

        if (position === 'x') {
            if (this.isMaximixedChatWindow) {
                dragHandle.style.transform = `translate3d(${translateX}px, 0, 0)`;
            } else {
                dragHandle.style.transform = 'translate3d(-3px, 0, 0)';
            }
        }

        if (position === 'y') {
            dragHandle.style.transform = `translate3d(-3px, -3px, 0)`;
        }

        if (position === 'both') {
            dragHandle.style.transform = 'translate3d(-1px, -1px, 0)';
        }
    }

    dragMove(dragHandle: HTMLElement, $event: CdkDragMove<any>) {
        this.ngZone.runOutsideAngular(() => {
            if (this.isMaximixedChatWindow) {
                this.resizeMaximized(dragHandle, this.resizeBoxElement);
            } else {
                this.resize(dragHandle, this.resizeBoxElement);
            }
        });
    }

    onMouseOverOpenMax() {
        this.isOpenMaxPopover = true;
    }

    onMouseOutCloseMax() {
        this.isOpenMaxPopover = false;
    }

    resetChatDimensions() {
        this.resizeBoxElement.style.width = '450px';
        this.resizeBoxElement.style.height = '450px';
        this.chatCurrentWidth = 450;
    }

    reassignChatDimensions() {
        this.resizeBoxElement.style.width = this.tempWidthChatBox;
        this.resizeBoxElement.style.height = this.tempHeigthChatBox;

        let tempWidth = this.tempWidthChatBox.replace('px', '');
        this.chatCurrentWidth = Number(tempWidth);
    }

    resize(dragHandle: HTMLElement, target: HTMLElement) {
        const MIN_WIDTH_DIMENSIONS_PX: number = 450;
        const MAX_WIDTH_DIMENSIONS_PX: number = window.innerWidth - 300;
        const MIN_HEIGHT_DIMENSIONS_PX: number = 450;
        const MAX_HEIGHT_DIMENSIONS_PX: number = window.innerHeight - 70;

        const dragRect = dragHandle.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        // console.log('dragRect: ', dragRect);
        // console.log('targetRect: ', targetRect);

        const width =
            (dragRect.left - targetRect.left + dragRect.width) * -1 +
            MIN_WIDTH_DIMENSIONS_PX;
        const height =
            (dragRect.top - targetRect.top + dragRect.height) * -1 +
            MIN_HEIGHT_DIMENSIONS_PX;

        // console.log('width: ', width, ' , height: ', height);

        let newWidth =
            width > MIN_WIDTH_DIMENSIONS_PX ? width : MIN_WIDTH_DIMENSIONS_PX;
        let newHeight =
            height > MIN_HEIGHT_DIMENSIONS_PX ? height : MIN_HEIGHT_DIMENSIONS_PX;

        newWidth =
            newWidth > MAX_WIDTH_DIMENSIONS_PX ? MAX_WIDTH_DIMENSIONS_PX : newWidth;
        newHeight =
            newHeight > MAX_HEIGHT_DIMENSIONS_PX
                ? MAX_HEIGHT_DIMENSIONS_PX
                : newHeight;

        // console.log('width: ', newWidth, ' , height: ', newHeight);

        target.style.width = newWidth + 'px';
        target.style.height = newHeight + 'px';

        this.chatCurrentWidth = newWidth;

        this.setAllHandleTransform();
    }

    resizeMaximized(dragHandle: HTMLElement, target: HTMLElement) {
        const MIN_WIDTH_DIMENSIONS_PX: number = 350;
        const MAX_WIDTH_DIMENSIONS_PX: number = window.innerWidth - 470;

        const dragRect = dragHandle.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        // console.log('dragRect: ', dragRect);
        // console.log('targetRect: ', targetRect);

        // const width = (((dragRect.left - targetRect.left) + dragRect.width) * -1) + MIN_WIDTH_DIMENSIONS_PX;
        const width = dragRect.left - targetRect.left + dragRect.width;

        // console.log('width: ', width);

        let newWidth =
            width > MIN_WIDTH_DIMENSIONS_PX ? width : MIN_WIDTH_DIMENSIONS_PX;

        newWidth =
            newWidth > MAX_WIDTH_DIMENSIONS_PX ? MAX_WIDTH_DIMENSIONS_PX : newWidth;

        let sideChatWidth = window.innerWidth - (newWidth + 20);

        // console.log('width: ', newWidth);

        target.style.width = newWidth + 'px';
        this.chatCurrentWidth = newWidth;

        this.sideChatDetailsBoxElement.style.width = sideChatWidth + 'px';

        this.setAllHandleTransform();
    }

    /* Swiper func to go specifiq slide */
    goToSlide(index: number) {
        if (this.chartsCarouselEl) {
            this.chartsCarouselEl.nativeElement.swiper.slideToLoop(index); // Use the slideTo method
        }
    }

    /* Image Fullscreen View */

    async onOpenImageViewerModal(imageURL: string) {
        const modal = await this.modalCtrl.create({
            component: MyImageSwiperPreviewModal,
            componentProps: {
                urlImage: imageURL,
            },
            cssClass: 'fullscreen transparent-modal',
        });

        modal.present();
    }

    async onOpenImageSwiperModal(imageIdx: number) {
        const swiperModal = await this.modalCtrl.create({
            component: MyImageSwiperViewModal,
            componentProps: {
                imagesURLs: this.imagesSlider,
                initialSlide: imageIdx,
                chartSlider: true,
            },
            cssClass: 'fullscreen transparent-modal',
        });
        return await swiperModal.present();
    }

    onSwiper(event: any) {
        // console.log(event);
    }

    onSlideChange(event: any) {
        /* let e: Swiper = event[0];
        const currentIndex = e.realIndex;
    
        console.log('Index : ', currentIndex, ', ', JSON.stringify(e));
        setTimeout(() => {
          this.sliderCurrentImgSlide = currentIndex + 1;
        }, 10); */
    }

    /* Parse and Generate excel file from Data */
    onParseDataToExcelFile(dataType: string) {

        let fileName: string;

        if (dataType === 'Financial') {

            fileName = 'FinancialData';

            this.excelExport.exportHtmlStringToExcel(this.tableFinanceDetail, fileName);

        } else {

            fileName = 'OperationsData';
            this.excelExport.exportHtmlStringToExcel(this.tableOperationsDetail, fileName);
        }
    }
}
